var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlpSki(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.8,77.9c0,2.8,2.3,5.1,5.1,5.1h34.4c1.3,0,2.6-0.5,3.6-1.5c1-1,1.5-2.3,1.5-3.6c0-1.3-0.5-2.6-1.5-3.6L43.5,44.8 c-4,4-4,10.5,0,14.5l13.4,13.4h-22C32.1,72.7,29.8,75.1,29.8,77.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,128.9L0,55.3v3.8l71.7,71.7c2,2,4.7,3,7.3,3s5.3-1,7.3-3l-1.9-1.9C81.5,131.9,76.6,131.9,73.6,128.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,72.7H92.8V50.1c0-2.3-0.9-4.6-2.6-6.4c-1.8-1.8-4.1-2.6-6.4-2.6H51L25.2,15.4l-1.9,1.9l59.2,59.2v1.4 c0,1.4,0.6,2.7,1.5,3.6c0.9,0.9,2.2,1.5,3.6,1.5H110c2.8,0,5.1-2.3,5.1-5.1S112.8,72.7,110,72.7z M69,59.1h13.5v13.5L69,59.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.9,
    cy: 50.1,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpSki);
export default __webpack_public_path__ + "static/media/alpSki.303468732d940342479bbc74a61a06ea.svg";
export { ForwardRef as ReactComponent };